import { h, Component } from 'preact';
import style from './style.less'
import {classNames} from '../../../lib/helpers'
import {FASpinner} from 'components/elements/FontAwesome'

export default (props)=>{
    let classes = [
        style.textCenter,
        props.class,
        style.largeLoading
    ]
    
    return (
        <div class={classNames(...classes)}>
            <FASpinner />
            &nbsp; Loading {props.children || props.loadingType}
        </div>
        
    )
}


// WEBPACK FOOTER //
// ./components/elements/Loading/index.js